import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import BizinBackend from "../../../../helpers/bizin_helper";
import TableSimple from "../../../../components/Dynamic/TableSimple";
import useGetCsrfToken from "../../../../Hooks/useGetCsrfToken";
import { DF_MO0006Context } from "../context";
import { Col, Row } from "reactstrap";
import CardFlow from "../../../../components/Common/CardFlow";
import CardContext from "../../../../components/Common/CardContext";

function GridBody() {
  const { access_token, isModalPage } = useSelector((state) => ({
    access_token: state.login.user.access_token,
    isModalPage: state.Layout.isModalPage,
  }));

  const csrfToken = useGetCsrfToken();
  const { parseParams } = useContext(DF_MO0006Context);
  const ID_Arquivo = parseParams.get("ID_Arquivo");

  const [dataTable, setDataTable] = useState([]);
  const [flowData, setFlowData] = useState([]);
  const [contextData, setContextData] = useState([]);

  const formatQuantity = (value) => {
    if (value === null || value === undefined) return "";

    return Number(value).toLocaleString("pt-BR", {
      minimumFractionDigits: 4,
      maximumFractionDigits: 4,
    });
  };

  useEffect(() => {
    if (!ID_Arquivo) return;

    const handleGetFlow = async () => {
      try {
        const resp = await BizinBackend.executeProcedure(
          { 1: ID_Arquivo },
          "FRONT_Workspace_Bloco_Fluxo",
          csrfToken,
          access_token,
        );

        const result =
          resp?.data?.resultset_1 ||
          resp?.resultset_1 ||
          (Array.isArray(resp) ? resp : []);

        const formattedFlow = result.map((item) => ({
          name: item.Nome_Empresa,
          description: item.Descricao,
          logo: item.Logo,
        }));

        setFlowData(formattedFlow);
      } catch (error) {
        console.log("erro ao carregar fluxo", error);
      }
    };

    const handleGetContext = async () => {
      const resp = await BizinBackend.executeProcedure(
        { 1: ID_Arquivo },
        "FRONT_Workspace_Bloco_Contexto_Saldo_Pedido",
        csrfToken,
        access_token,
      );

      const result = Array.isArray(resp) ? resp : [];

      const formattedContext = result.map((item) => ({
        label: item.Coluna,
        value: item.Valor,
      }));

      setContextData(formattedContext);
    };

    const handleGetData = async () => {
      try {
        const resp = await BizinBackend.executeProcedure(
          { 1: ID_Arquivo },
          "SRM_Get_Pedidos_Pendente_Detalhe",
          csrfToken,
          access_token,
        );

        const result =
          resp?.data?.resultset_1 ||
          resp?.resultset_1 ||
          (Array.isArray(resp) ? resp : []);

        if (Array.isArray(result) && result.length > 0) {
          const formattedData = result.map((item) => ({
            ...item,

            rowKey: `${item.Numero_Pedido?.trim?.() || ""}-${item.Numero_Item}`,

            Numero_Pedido: item.Numero_Pedido?.trim?.() || "",

            Valor_Unitario_Produto_Bruto:
              item.Valor_Unitario_Produto_Bruto != null
                ? Number(item.Valor_Unitario_Produto_Bruto).toLocaleString(
                    "pt-BR",
                    {
                      style: "currency",
                      currency: "BRL",
                    },
                  )
                : "",

            Quantidade_Pedida: formatQuantity(item.Quantidade_Pedida),
            Quantidade_Total_Faturada: formatQuantity(
              item.Quantidade_Total_Faturada,
            ),
            Saldo_Item: formatQuantity(item.Saldo_Item),
            Quantidade_Total_Anulada: formatQuantity(
              item.Quantidade_Total_Anulada,
            ),
            Data_Emissao: item.Data_Emissao
              ? new Date(item.Data_Emissao)
                  .toLocaleDateString("pt-BR")
                  .replaceAll("/", "-")
              : "",
          }));

          setDataTable(formattedData);
        } else {
          setDataTable([]);
        }
      } catch (error) {
        console.log("error ao carregar pedidos pendentes detalhe", error);
      }
    };

    handleGetFlow();
    handleGetContext();
    handleGetData();
  }, [ID_Arquivo, csrfToken, access_token]);

  const renderExpandedRow = (rowData) => {
    return (
      <div className="p-3 ms-4">
        <div className="row">
          <div className="col-md-3">
            <strong>Qtde Anulada:</strong>
            <div>{rowData?.Quantidade_Total_Anulada ?? "-"}</div>
          </div>

          <div className="col-md-3">
            <strong>Número NF:</strong>
            <div>{rowData?.Numero_NF || "-"}</div>
          </div>

          <div className="col-md-3">
            <strong>Data Emissão:</strong>
            <div>{rowData?.Data_Emissao || "-"}</div>
          </div>

          <div className="col-md-3">
            <strong>Qtde Faturada:</strong>
            <div>{rowData?.Quantidade_Faturada ?? "-"}</div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Row className="my-3">
        <Col md={isModalPage ? 12 : 4}>
          {flowData.length > 0 && (
            <div className="mt-3 mb-2">
              <CardFlow flowData={flowData} />
            </div>
          )}
        </Col>
        <Col md={isModalPage ? 12 : 8}>
          {contextData.length > 0 && (
            <div className="mb-3">
              <CardContext data={contextData} />
            </div>
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          {dataTable.length > 0 && (
            <TableSimple
              data={dataTable}
              dataKey="rowKey"
              enableRowExpansion
              rowExpansionTemplate={renderExpandedRow}
              columnsList={[
                { field: "Numero_Pedido", header: "Numero Pedido" },
                { field: "Numero_Item", header: "Numero Item" },
                { field: "Codigo_Barras_Produto", header: "Código Barras" },
                { field: "Descricao_Produto", header: "Desc Produto" },
                {
                  field: "Valor_Unitario_Produto_Bruto",
                  header: "Valor Unitário",
                },
                { field: "Quantidade_Pedida", header: "Qtde Pedida" },
                { field: "Unidade_Medida", header: "Unid Medida" },
                { field: "Quantidade_Total_Faturada", header: "Qtde Atendida" },
                { field: "Saldo_Item", header: "Saldo" },
              ]}
            />
          )}
        </Col>
      </Row>
    </>
  );
}

export default GridBody;
